import { mapByScoreToRecommendations, mapToRecommendations } from './utils';
import { addAbsolutePosition } from './utils/addAbsolutePosition';
import { addIndexName } from './utils/addIndexName';
import { version } from './version';
export async function getBatchRecommendations({
  keys,
  queries,
  recommendClient
}) {
  recommendClient.addAlgoliaAgent('recommend-core', version);
  const response = await recommendClient.getRecommendations(queries);
  let prevChunks = 0;
  let allChunks = 0;
  const results = {};
  keys.forEach(keyPair => {
    const {
      model
    } = JSON.parse(keyPair.key);
    allChunks += keyPair.value;
    const {
      indexName,
      maxRecommendations,
      transformItems = x => x
    } = queries[prevChunks];
    const splitResult = response?.results?.slice(prevChunks, allChunks);
    prevChunks += keyPair.value;
    let recommendations = [];
    let trendingFacets = [];
    if (model === 'trending-facets') {
      trendingFacets = splitResult.map(res => res.hits).flat();
    } else if (model === 'trending-items') {
      recommendations = mapByScoreToRecommendations({
        maxRecommendations,
        hits: splitResult.map(res => res.hits).flat(),
        indexName,
        queryID: splitResult.at(0)?.queryID
      });
    } else {
      recommendations = mapToRecommendations({
        maxRecommendations,
        hits: splitResult.map(res => res.hits),
        nrOfObjs: keyPair.value,
        queryIDs: splitResult.map(res => res.queryID)
      }).map(hit => addIndexName(hit, indexName)).map((hit, idx) => addAbsolutePosition(hit, idx));
    }
    recommendations = transformItems(recommendations);
    results[keyPair.key] = {
      recommendations,
      trendingFacets
    };
  });
  return results;
}